import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Home } from 'lucide-react';
import { DjayAvatar } from '../../../mascot';
import { Button } from '../../../components/ui/Button';
import { SummaryShell } from './SummaryShell';
/**
 * AbortedSummary — edge case for sessions that ended before any answers
 * were submitted (§20.7 G6).
 *
 * Shown when sessionAnswers is empty. Friendly, no scoring, no Djay-tip
 * pressure — just a soft "wil je het opnieuw proberen?" with two clear
 * exits.
 */
interface AbortedSummaryProps {
  onPracticeAgain?: () => void;
  onExit: () => void;
}
export function AbortedSummary({
  onPracticeAgain,
  onExit
}: AbortedSummaryProps) {
  return <SummaryShell tone="aborted" data-id="element-12112">
      <div className="flex w-full max-w-md flex-col items-center text-center" data-id="element-12113">
        <motion.div initial={{
        scale: 0.85,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        type: 'spring',
        stiffness: 220,
        damping: 18
      }} className="mb-4" data-id="element-12114">
          <DjayAvatar emotion="thinking" size="lg" data-id="element-12115" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 6
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.15
      }} className="text-2xl font-bold text-slate-800" data-id="element-12116">
          Geen vragen gemaakt
        </motion.h2>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.3
      }} className="mt-2 max-w-xs text-sm leading-relaxed text-slate-600" data-id="element-12117">
          Geen probleem — je kunt elk moment weer beginnen. Een korte ronde van
          5 minuten is al genoeg.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.45
      }} className="mt-6 flex w-full flex-col gap-2.5" data-id="element-12118">
          {onPracticeAgain && <Button size="xl" onClick={onPracticeAgain} className="w-full text-base" autoFocus data-id="element-12119">
              Toch even oefenen <ArrowRight className="ml-2 h-5 w-5" data-id="element-12120" />
            </Button>}
          <button type="button" onClick={onExit} className="flex w-full items-center justify-center gap-2 py-2.5 text-sm font-medium text-slate-500 transition-colors hover:text-slate-700" data-id="element-12121">
            <Home className="h-4 w-4" data-id="element-12122" />
            Terug naar start
          </button>
        </motion.div>
      </div>
    </SummaryShell>;
}